import { push } from 'connected-react-router';
import * as ActionTypes from '../../constants/ActionTypes';
import API from '../../helpers/api';

export function getBookingGuidelines() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_BOOKING_GUIDELINES_REQUEST,
			payload: { loading: true }
		});

		const response = await API.booking_guidelines.getBookingGuidelines();

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_BOOKING_GUIDELINES_ERROR,
				payload: {
					meta: response.meta,
					loading: false
				}
			});
			return;
		}

		dispatch({
			type: ActionTypes.GET_BOOKING_GUIDELINES_SUCCESS,
			payload: {
				booking_guidelines: response.data.booking_guidelines,
				loading: false
			}
		});
	};
}

export function getApplicationById(id) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_APPLICATION_BY_ID_REQUEST,
			payload: {
				loading: true
			}
		});

		const response = await API.booking.getApplicationById(id);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_APPLICATION_BY_ID_ERROR,
				payload: {
					meta: response.meta,
					loading: false
				}
			});
			return dispatch(push('/applications'));
		}

		dispatch({
			type: ActionTypes.GET_APPLICATION_BY_ID_SUCCESS,
			payload: {
				application: response.data.application,
				loading: false
			}
		});
	};
}

export function onBookingGuidelinesViewSubmit() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.SUBMIT_START_APPLICATION_REQUEST,
			payload: { loadingSubmit: true }
		});

		const response = await API.booking.createApplication();

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.SUBMIT_START_APPLICATION_ERROR,
				payload: {
					meta: response.meta,
					loadingSubmit: false
				}
			});

			if (response.meta.code === 409) {
				const { application } = response.data;
				dispatch(push(`/applications/id/basic?id=${application._id}`));
			}
			return;
		}

		const { application } = response.data;

		dispatch({
			type: ActionTypes.SUBMIT_START_APPLICATION_SUCCESS,
			payload: {
				loadingSubmit: false,
				application
			}
		});

		dispatch(push(`/applications/id/basic?id=${application._id}`));
	};
}

export function onSubmit(fields) {
	return async (dispatch, getState) => {
		const { application } = getState().applicationDetailPage.applicationBasicPageReducer;

		dispatch({
			type: ActionTypes.SUBMIT_APPLICATION_REQUEST,
			payload: {
				loadingSubmit: true
			}
		});

		const body = {
			application: {
				...fields
			}
		};

		let response;
		if (application) {
			body.application.updated_at = application.updated_at;
			response = await API.booking.updateApplicationById({ id: application._id }, body);
		} else {
			response = await API.booking.createApplication(body);
		}

		if (response.meta.code !== 200) {
			return dispatch({
				type: ActionTypes.SUBMIT_APPLICATION_ERROR,
				payload: {
					meta: response.meta,
					loadingSubmit: false,
					...(response.meta.code === 410 && { application: response.data.application })
				}
			});
		}

		const { application: newData } = response.data;

		dispatch({
			type: ActionTypes.SUBMIT_APPLICATION_SUCCESS,
			payload: {
				application: newData,
				loadingSubmit: false,
				meta: response.meta
			}
		});

		if (newData) {
			dispatch(getApplicationById(newData._id));
		}

		dispatch(push(`/applications/id/basic?id=${newData._id}`));
	};
}

export function createInstantBooking(fields) {
	return async (dispatch, getState) => {
		dispatch({
			type: ActionTypes.SUBMIT_INSTANT_BOOKING_REQUEST,
			payload: {
				loadingInstantSubmit: true
			}
		});

		const response = await API.booking.createApplication({
			application: {
				...fields
			}
		});

		if (response.meta.code !== 200) {
			return dispatch({
				type: ActionTypes.SUBMIT_INSTANT_BOOKING_ERROR,
				payload: {
					meta: response.meta,
					loadingInstantSubmit: false,
					...(response.meta.code === 410 && { application: response.data.application })
				}
			});
		}

		const { application: newData } = response.data;

		dispatch({
			type: ActionTypes.SUBMIT_INSTANT_BOOKING_SUCCESS,
			payload: {
				application: newData,
				loadingInstantSubmit: false,
				meta: response.meta
			}
		});

		if (newData) {
			dispatch(getApplicationById(newData._id));
		}
		dispatch(push(`/applications/id/basic?id=${newData._id}`));
	};
}

export function createFavoriteLocation(fields) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.SUBMIT_APPLICATION_FAVORITE_DESTINATION_REQUEST,
			payload: {
				loadingFavoriteLocationSubmit: true
			}
		});

		const body = {
			favorite_destination: {
				...fields
			}
		};

		let response = await API.favorite_destination.createFavoriteDestinations(body);

		if (response.meta.code !== 200) {
			return dispatch({
				type: ActionTypes.SUBMIT_APPLICATION_FAVORITE_DESTINATION_ERROR,
				payload: {
					meta: response.meta,
					loadingFavoriteLocationSubmit: false
				}
			});
		}

		dispatch({
			type: ActionTypes.SUBMIT_APPLICATION_FAVORITE_DESTINATION_SUCCESS,
			payload: {
				loadingFavoriteLocationSubmit: false,
				meta: response.meta
			}
		});
	};
}

export function cancelApplicationTripById(applicationTripId, fields) {
	return async (dispatch, getState) => {
		const { application } = getState().applicationDetailPage.applicationBasicPageReducer;

		dispatch({
			type: ActionTypes.UPDATE_APPLICATION_STATUS_REQUEST,
			payload: {
				loadingStatus: true
			}
		});

		const body = {
			application: {
				...fields,
				updated_at: application.updated_at
			}
		};

		const updateResponse = await API.booking.updateApplicationById({ id: application._id, skip_email: 'yes' }, body);
		if (updateResponse.meta.code !== 200) {
			return dispatch({
				type: ActionTypes.UPDATE_APPLICATION_STATUS_ERROR,
				payload: {
					meta: updateResponse.meta,
					loadingStatus: false
				}
			});
		}

		const cancelResponse = await API.booking.cancelApplicationTripById(applicationTripId);
		if (cancelResponse.meta.code !== 200) {
			return dispatch({
				type: ActionTypes.UPDATE_APPLICATION_STATUS_ERROR,
				payload: {
					meta: cancelResponse.meta,
					loadingStatus: false
				}
			});
		}

		// window.alert('One trip cancelled.');
		// window.location.reload();

		const { application: newData } = cancelResponse.data;

		dispatch({
			type: ActionTypes.UPDATE_APPLICATION_STATUS_SUCCESS,
			payload: {
				application: newData,
				loadingStatus: false,
				meta: cancelResponse.meta
			}
		});
		if (newData) {
			dispatch(getApplicationById(newData._id));
		}
		dispatch(push(`/applications/id/basic?id=${newData._id}`));
	};
}

export function getHkustPoints() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_APPLICATION_HKUST_POINTS_REQUEST,
			payload: {
				loading: false
			}
		});

		const response = await API.hkust_point.getHkustPoints();

		if (response.meta.code !== 200) {
			return dispatch({
				type: ActionTypes.GET_APPLICATION_HKUST_POINTS_ERROR,
				payload: {
					loading: false
				}
			});
		}

		dispatch({
			type: ActionTypes.GET_APPLICATION_HKUST_POINTS_SUCCESS,
			payload: {
				hkust_points: response.data.hkust_points,
				loading: false
			}
		});
	};
}

export function getFavoriteDestinations() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_APPLICATION_FAVORITE_DESTINATIONS_REQUEST,
			payload: {
				loading: true
			}
		});

		const response = await API.favorite_destination.getFavoriteDestinations();

		if (response.meta.code !== 200) {
			return dispatch({
				type: ActionTypes.GET_APPLICATION_FAVORITE_DESTINATIONS_ERROR,
				payload: {
					meta: response.meta,
					loading: false
				}
			});
		}

		dispatch({
			type: ActionTypes.GET_APPLICATION_FAVORITE_DESTINATIONS_SUCCESS,
			payload: {
				favorite_destinations: response.data.favorite_destinations,
				loading: false
			}
		});
	};
}

export function getStaffs() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_APPLICATION_STAFFS_REQUEST,
			payload: {
				loadingStaffs: true
			}
		});

		const response = await API.staff.getStaffs();

		if (response.meta.code !== 200) {
			return dispatch({
				type: ActionTypes.GET_APPLICATION_STAFFS_ERROR,
				payload: {
					meta: response.meta,
					loadingStaffs: false
				}
			});
		}

		dispatch({
			type: ActionTypes.GET_APPLICATION_STAFFS_SUCCESS,
			payload: {
				staffs: response.data.staffs,
				loadingStaffs: false
			}
		});
	};
}

export function getApplicationPreviousBookings() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_APPLICATION_PREVIOUS_BOOKINGS_REQUEST
		});

		const response = await API.booking.getApplicationPreviousBookings();

		if (response.meta.code !== 200) {
			return dispatch({
				type: ActionTypes.GET_APPLICATION_PREVIOUS_BOOKINGS_ERROR,
				payload: {
					meta: response.meta
				}
			});
		}

		dispatch({
			type: ActionTypes.GET_APPLICATION_PREVIOUS_BOOKINGS_SUCCESS,
			payload: {
				previous_bookings: response.data.previous_bookings
			}
		});
	};
}

export function cancelAllTrips(fields) {
	return async (dispatch, getState) => {
		const { application } = getState().applicationDetailPage.applicationBasicPageReducer;

		dispatch({
			type: ActionTypes.CANCEL_ALL_TRIPS_REQUEST,
			payload: {
				loadingCancel: true
			}
		});

		const body = {
			application: {
				...fields,
				updated_at: application.updated_at
			}
		};

		const updateResponse = await API.booking.updateApplicationById({ id: application._id, skip_email: 'yes' }, body);
		if (updateResponse.meta.code !== 200) {
			return dispatch({
				type: ActionTypes.CANCEL_ALL_TRIPS_ERROR,
				payload: {
					meta: updateResponse.meta,
					loadingCancel: false
				}
			});
		}

		const cancelResponse = await API.booking.cancelAllTrips(application._id);
		if (cancelResponse.meta.code !== 200) {
			return dispatch({
				type: ActionTypes.CANCEL_ALL_TRIPS_ERROR,
				payload: {
					meta: cancelResponse.meta,
					loadingCancel: false
				}
			});
		}

		const { application: newData } = cancelResponse.data;

		dispatch({
			type: ActionTypes.CANCEL_ALL_TRIPS_SUCCESS,
			payload: {
				application: newData,
				loadingCancel: false,
				meta: cancelResponse.meta
			}
		});
		if (newData) {
			dispatch(getApplicationById(newData._id));
		}
		dispatch(push(`/applications/id/basic?id=${newData._id}`));
	};
}

export function resetMeta() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_APPLICATION_META
		});
	};
}

export function resetPage() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_APPLICATION_PAGE
		});
	};
}
